import { Widget, WIDGET_LIVETABLE } from "@gaming/srvg-classes-core";


export class LivetableWidget extends Widget {
    widgetName: string;
    widget: any;
    onLoad: any;
    currentGroup: string;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#livetableWidget';
        super( options );

        var self = this;
        this.onLoad = options.onLoad || function(widget) { self.setGroup(); };
        delete(options.onLoad);

        this.name = 'widgetlivetable';
        this.widgetName = options.widgetName || WIDGET_LIVETABLE;
        this.widgetName = this.product + this.widgetName;


        this.widget = null;

        this.widgetOptions = {
            height: this.getContainerHeightWithUnit(),
        };

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addLivetableWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livetable widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addLivetableWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions,
            this.onLoad
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLivetableWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addLivetableWidget(element);
    }


    /**
     * calls widget api setGroup to switch the active group.
     * @param group, string representation of group e.g. 'A'
     */
    setGroup(group?:string){
        group = group || this.currentGroup || null;
        this.currentGroup = group;
        if(group && this.widget && this.widget.api && this.widget.api.setGroup){
            this.widget.api.setGroup(group);
        }
    }

}
